// tablesorter (Mottie fork) — jQuery plugin with widgets.
// Importing attaches $.fn.tablesorter and the bundled widgets to jQuery.
import 'tablesorter';

export {};
